import { useEffect, useRef, useState } from "react";
import { lerTextoDaImagem, validarImagem, type FonteLeitura, type Idioma } from "../lib/lerImagem";

export type EstadoAnexo =
  | { etapa: "vazio" }
  | { etapa: "lendo"; previa: string; progresso: number; fonte: FonteLeitura }
  | { etapa: "pronto"; previa: string; texto: string }
  | { etapa: "erro"; previa?: string; motivo: "tipo" | "tamanho" | "leitura" };

export const useAnexoImagem = (idioma: Idioma) => {
  const [estado, setEstado] = useState<EstadoAnexo>({ etapa: "vazio" });
  // Descarta o resultado de uma leitura antiga se a pessoa trocou/removeu a imagem no meio.
  const leituraAtual = useRef(0);
  const previaAtual = useRef<string | null>(null);

  const liberarPrevia = () => {
    if (previaAtual.current) URL.revokeObjectURL(previaAtual.current);
    previaAtual.current = null;
  };

  useEffect(() => liberarPrevia, []);

  const anexar = async (arquivo: File) => {
    const invalida = validarImagem(arquivo);
    if (invalida) {
      setEstado({ etapa: "erro", motivo: invalida });
      return;
    }

    liberarPrevia();
    const previa = URL.createObjectURL(arquivo);
    previaAtual.current = previa;
    const leitura = ++leituraAtual.current;
    setEstado({ etapa: "lendo", previa, progresso: 0, fonte: "ia" });

    try {
      const { texto } = await lerTextoDaImagem(arquivo, idioma, (progresso, fonte) => {
        if (leitura === leituraAtual.current) setEstado({ etapa: "lendo", previa, progresso, fonte });
      });
      if (leitura === leituraAtual.current) setEstado({ etapa: "pronto", previa, texto });
    } catch (erro) {
      console.error(erro);
      if (leitura === leituraAtual.current) setEstado({ etapa: "erro", previa, motivo: "leitura" });
    }
  };

  const remover = () => {
    leituraAtual.current++;
    liberarPrevia();
    setEstado({ etapa: "vazio" });
  };

  return { estado, anexar, remover };
};
